import { useEffect, useState } from "react";
import { useLocale } from "@lib/i18n/navigation-pages-router";
import { getStoryblokStory } from "@utils/call-api/storyblok-call";
import StoryblokComponent from "@components/core/Storyblok/StoryblokComponent";
import { useCurrentUser } from "@hooks/use-current-user";

function ClosetPromoBannerContainer() {
  const user = useCurrentUser();
  const locale = useLocale();
  const isLoggedIn = Boolean(user);
  const canPreview = Boolean(user?.permissions?.includes("storyblok"));

  const [story, setStory] = useState();

  useEffect(() => {
    const fetchStoryblokStory = async () => {
      if (!isLoggedIn) return;

      const storySlug = `common/promobanner/${process.env.NEXT_PUBLIC_CUSTOMER}/closet-promo-banner`;
      const storyParams = {
        language: locale,
        ...(canPreview && { version: "draft" }),
      };
      const data = await getStoryblokStory(storySlug, storyParams);

      setStory(data.story);
    };

    fetchStoryblokStory();
  }, [isLoggedIn, canPreview, locale]);

  if (!story) return null;

  return <StoryblokComponent story={story} />;
}

export default ClosetPromoBannerContainer;
